const DEFAULT_APP_CONFIG_DEV = {
    ATTENTION_HOUR_START: '00:00',
    ATTENTION_HOUR_END: '23:59',
    MAINTENANCE_MODE: '0',
    MAINTENANCE_HOUR_START: '00:00',
    MAINTENANCE_HOUR_END: '00:00',
    APP_VERSION: '1.6.0',
    HOUR_WEEK_HOUR_START: '21:00',
    HOUR_WEEK_HOUR_END: '05:00',
    REACT_APP_REMOTE_CONFIG_REFRESH_INTERVAL_MINUTES: 1,
    REACT_APP_MIN_FETCH_INTERVAL_MILLIS: '15000',
    REACT_APP_FETCH_TIMEOUT_MILLIS: '10000',
    REACT_APP_FIREBASE_API_KEY: 'AIzaSyBb2bL1cZ47zNArQdfpSYbdrj5aNkmb93I',
    REACT_APP_FIREBASE_AUTH_DOMAIN: 'web-landing-pasivos-dev.firebaseapp.com',
    REACT_APP_FIREBASE_PROJECT_ID: 'web-landing-pasivos-dev',
    REACT_APP_FIREBASE_STORAGE_BUCKET: 'web-landing-pasivos-dev.firebasestorage.app',
    REACT_APP_FIREBASE_MESSAGING_SENDER_ID: '395600209126',
    REACT_APP_FIREBASE_APP_ID: '1:395600209126:web:deb379efe22164ad554727',
    REACT_APP_FIREBASE_MEASUREMENT_ID: 'G-26KEWXD84S',
    REACT_APP_FIREBASE_VAPID_KEY: 'BP9_BKDXRgLmZ5OHAuHgkX7FQq0KZYMC37MqifQk6eTnPZ8yBTRm0T22ToONuYJgDg3vvo6QsLVwJw93APwbnbw'
};
const DEFAULT_APP_CONFIG_QA = {
    ATTENTION_HOUR_START: '00:00',
    ATTENTION_HOUR_END: '23:59',
    MAINTENANCE_MODE: '0',
    MAINTENANCE_HOUR_START: '00:00',
    MAINTENANCE_HOUR_END: '00:00',
    APP_VERSION: '1.6.0',
    HOUR_WEEK_HOUR_START: '21:00',
    HOUR_WEEK_HOUR_END: '05:00',
    REACT_APP_REMOTE_CONFIG_REFRESH_INTERVAL_MINUTES: 1,
    REACT_APP_MIN_FETCH_INTERVAL_MILLIS: '300000',
    REACT_APP_FETCH_TIMEOUT_MILLIS: '20000',
    REACT_APP_FIREBASE_API_KEY: 'AIzaSyCR-J9X6lpXj3e3L9xCWAFePQs7Pd37rv0',
    REACT_APP_FIREBASE_AUTH_DOMAIN: 'web-landing-pasivos-qa.firebaseapp.com',
    REACT_APP_FIREBASE_PROJECT_ID: 'web-landing-pasivos-qa',
    REACT_APP_FIREBASE_STORAGE_BUCKET: 'web-landing-pasivos-qa.firebasestorage.app',
    REACT_APP_FIREBASE_MESSAGING_SENDER_ID: '334888802370',
    REACT_APP_FIREBASE_APP_ID: '1:334888802370:web:6e2d6be0b2e4369b3d75db',
    REACT_APP_FIREBASE_MEASUREMENT_ID: 'G-HLVE69N0C0',
    REACT_APP_FIREBASE_VAPID_KEY: 'BCBqBeeFVPrhgKH8acBM4LT6SLRWtzOuc-WEc6gTd63dsJ5vaMNdg5Y0tq3FgFwWO6JtgRIdfj6h5Qj44Q1gMJg',
};
const DEFAULT_APP_CONFIG_STAG = {
    ATTENTION_HOUR_START: '05:00',
    ATTENTION_HOUR_END: '21:00',
    MAINTENANCE_MODE: '0',
    MAINTENANCE_HOUR_START: '00:00',
    MAINTENANCE_HOUR_END: '00:00',
    APP_VERSION: '1.6.0',
    HOUR_WEEK_HOUR_START: '21:00',
    HOUR_WEEK_HOUR_END: '05:00',
    REACT_APP_REMOTE_CONFIG_REFRESH_INTERVAL_MINUTES: 1,
    REACT_APP_MIN_FETCH_INTERVAL_MILLIS: '1800000',
    REACT_APP_FETCH_TIMEOUT_MILLIS: '60000',
    REACT_APP_FIREBASE_API_KEY: 'AIzaSyAA8dZ6snXdknz0jXpCPzWRDJdV3-YNpJQ',
    REACT_APP_FIREBASE_AUTH_DOMAIN: 'web-landing-pasivos-prod.firebaseapp.com',
    REACT_APP_FIREBASE_PROJECT_ID: 'web-landing-pasivos-prod',
    REACT_APP_FIREBASE_STORAGE_BUCKET: 'web-landing-pasivos-prod.firebasestorage.app',
    REACT_APP_FIREBASE_MESSAGING_SENDER_ID: '554359963623',
    REACT_APP_FIREBASE_APP_ID: '1:554359963623:web:27588b4a41ce2dbe6a4742',
    REACT_APP_FIREBASE_MEASUREMENT_ID: 'G-6YMYKN4MFM',
    REACT_APP_FIREBASE_VAPID_KEY: 'BCBqBeeFVPrhgKH8acBM4LT6SLRWtzOuc-WEc6gTd63dsJ5vaMNdg5Y0tq3FgFwWO6JtgRIdfj6h5Qj44Q1gMJg'
};
const DEFAULT_APP_CONFIG_PROD = {
    ATTENTION_HOUR_START: '05:00',
    ATTENTION_HOUR_END: '21:00',
    MAINTENANCE_MODE: '0',
    MAINTENANCE_HOUR_START: '00:00',
    MAINTENANCE_HOUR_END: '00:00',
    APP_VERSION: '1.6.0',
    HOUR_WEEK_HOUR_START: '21:00',
    HOUR_WEEK_HOUR_END: '05:00',
    REACT_APP_REMOTE_CONFIG_REFRESH_INTERVAL_MINUTES: 5,
    REACT_APP_MIN_FETCH_INTERVAL_MILLIS: '1800000',
    REACT_APP_FETCH_TIMEOUT_MILLIS: '60000',
    REACT_APP_FIREBASE_API_KEY: 'AIzaSyAA8dZ6snXdknz0jXpCPzWRDJdV3-YNpJQ',
    REACT_APP_FIREBASE_AUTH_DOMAIN: 'web-landing-pasivos-prod.firebaseapp.com',
    REACT_APP_FIREBASE_PROJECT_ID: 'web-landing-pasivos-prod',
    REACT_APP_FIREBASE_STORAGE_BUCKET: 'web-landing-pasivos-prod.firebasestorage.app',
    REACT_APP_FIREBASE_MESSAGING_SENDER_ID: '554359963623',
    REACT_APP_FIREBASE_APP_ID: '1:554359963623:web:27588b4a41ce2dbe6a4742',
    REACT_APP_FIREBASE_MEASUREMENT_ID: 'G-6YMYKN4MFM',
    REACT_APP_FIREBASE_VAPID_KEY: 'BLoHQXCSl_p9KK7w6_rlRnABewzRQBSArPFxp1YPng34pnhWRAfJrsQjpO9-YFynebVm25-k7z5kpKf-mSr5C_A'
};
const ENV = process.env.ENVIRONMENT || 'DEBUG';
export const getDefaultAppConfig = () => {
    switch (ENV.toUpperCase()) {
        case 'QA':
            return DEFAULT_APP_CONFIG_QA;
        case 'STAG':
            return DEFAULT_APP_CONFIG_STAG;
        case 'PROD':
            return DEFAULT_APP_CONFIG_PROD;
        case 'DEV':
        default:
            return DEFAULT_APP_CONFIG_DEV;
    }
};
